import React, { FC, useEffect } from "react";
import { SlideFade, Collapse } from "../Transition/Transition";

const TRANSITION_COMPONENT = {
  "slide-fade": SlideFade,
  collapse: Collapse,
};

type Props = {
  delay?: number | string;
  transition?: keyof typeof TRANSITION_COMPONENT;
  children: React.ReactNode;
  offsetY?: string;
  onExpire?: () => void;
};

export const Expire: FC<Props> = ({
  delay,
  children,
  transition,
  onExpire,
}) => {
  const [visible, setVisible] = React.useState(true);

  useEffect(() => {
    if (delay) {
      setTimeout(() => {
        setVisible(false);
        setTimeout(() => {
          onExpire && onExpire();
        }, 300);
      }, Number(delay));
    }
  }, [delay]);

  if (transition) {
    const TransitionComponent = TRANSITION_COMPONENT[transition];
    return <TransitionComponent in={visible}>{children}</TransitionComponent>;
  }

  return visible ? <>{children}</> : null;
};
